import React from 'react';
import styles from './Radio.module.css';

const Radio = ({
    id,
    name,
    label,
    checked = false,
    onChange,
    disabled = false,
    value,
    size = 'md',
    className = '',
    required = false,
    'aria-describedby': ariaDescribedBy
}) => {
    const handleChange = (e) => {
        if (!disabled && onChange) {
            onChange(e.target.checked, value);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (!disabled && onChange) {
                onChange(!checked, value);
            }
        }
    };

    return (
        <div
            className={`${styles.radioWrapper} ${disabled ? styles.disabled : ''} ${className}`}
            role="radio"
            aria-checked={checked}
            aria-disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            onKeyDown={handleKeyDown}
        >
            <input
                type="radio"
                id={id}
                name={name}
                checked={checked}
                onChange={handleChange}
                disabled={disabled}
                value={value}
                required={required}
                aria-describedby={ariaDescribedBy}
                className={styles.input}
            />
            <label
                htmlFor={id}
                className={`${styles.radioVisual} ${styles[size]}`}
                onClick={(e) => {
                    if (!disabled) {
                        e.preventDefault();
                        onChange(!checked, value);
                    }
                }}
            >
                <span className={styles.radioOuter} />
                <span className={styles.radioInner} />
            </label>
            {label && (
                <label
                    htmlFor={id}
                    className={`${styles.label} ${disabled ? styles.labelDisabled : ''}`}
                >
                    {label}
                </label>
            )}
        </div>
    );
};

export default Radio;
